module.exports = __webpack_public_path__ + "images/ui-bg_gloss-wave_35_f6a828_500x100.png";